module.exports = "<section class=\"nn-social-extended container--large\"><div ng-transclude></div><div class=\"nn-social-extended__container container\" ng-if=loaded><nn-base-module-header title=::item.title url=::item.jsonData.moduleUrl></nn-base-module-header><div class=nn-social-extended__content><a class=nn-social-extended__post ng-repeat=\"social in socials track by $index\" href=\"{{ social.url }}\"><nn-base-img src=social.imageUrl aspect-ratio=1></nn-base-img></a></div></div></section>"


//////////////////
// WEBPACK FOOTER
// ./app/components/nn-modules/nn-social-extended/nn-social-extended.directive.html
// module id = 1009
// module chunks = 0